import { useState, useEffect } from "react";

const API = process.env.REACT_APP_BACKEND_URL || "";

export function VersionBadge() {
  const [version, setVersion] = useState(null);
  const [dbStatus, setDbStatus] = useState(null);
  const [showDbInfo, setShowDbInfo] = useState(false);

  useEffect(() => {
    fetch(`${API}/api/version?t=${Date.now()}`)
      .then((res) => res.json())
      .then((data) => setVersion(data))
      .catch(() => setVersion({ push_version: "", push_date: "" }));
  }, []);

  useEffect(() => {
    const checkDb = () => {
      fetch(`${API}/api/health/db`)
        .then((r) => r.json())
        .then((d) => setDbStatus(d))
        .catch(() => setDbStatus({ connected: false }));
    };
    checkDb();
    const interval = setInterval(checkDb, 30000);
    return () => clearInterval(interval);
  }, []);

  if (!version) return null;

  // Display push_date directly — it's already formatted as "mm/dd/yy--hh:mm AM/PM" EST by the pre-push hook
  const prettyDate = (raw) => {
    if (!raw) return "Not yet pushed";
    // "04/21/26--08:54 PM" → "Apr 21, 2026 8:54 PM EST"
    const m = raw.match(/^(\d{2})\/(\d{2})\/(\d{2})--(\d{1,2}):(\d{2})\s?(AM|PM)$/i);
    if (!m) return raw + " EST";
    const [, mm, dd, yy, hh, min, ap] = m;
    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    return `${months[parseInt(mm,10)-1]} ${parseInt(dd,10)}, 20${yy} ${parseInt(hh,10)}:${min} ${ap.toUpperCase()} EST`;
  };

  return (
    <div
      className="fixed bottom-4 right-4 flex items-center gap-2 text-xs text-slate-500 bg-white/90 backdrop-blur-sm px-3 py-2 rounded-lg shadow-sm border border-slate-200 z-50"
      data-testid="version-badge"
    >
      <div className="relative">
        <span
          className={`inline-block w-2 h-2 rounded-full cursor-pointer ${
            dbStatus === null ? "bg-yellow-400 animate-pulse" :
            dbStatus?.connected ? "bg-emerald-500" : "bg-red-500"
          }`}
          onClick={() => setShowDbInfo(!showDbInfo)}
        />
        {showDbInfo && dbStatus?.connected && (
          <div className="absolute bottom-full right-0 mb-2 bg-white border border-slate-200 rounded-lg shadow-lg p-3 text-xs text-slate-600 w-52 z-50">
            <div className="font-semibold text-slate-800 mb-2">Database Info</div>
            <div className="space-y-1">
              <div className="flex justify-between"><span className="text-slate-400">Server</span><span className="font-mono">{dbStatus.server}</span></div>
              <div className="flex justify-between"><span className="text-slate-400">Port</span><span className="font-mono">{dbStatus.port}</span></div>
              <div className="flex justify-between"><span className="text-slate-400">Database</span><span className="font-mono">{dbStatus.dbName}</span></div>
              <div className="flex justify-between"><span className="text-slate-400">Size</span><span className="font-mono">{dbStatus.sizeMB} MB</span></div>
              <div className="flex justify-between"><span className="text-slate-400">Collections</span><span className="font-mono">{dbStatus.collections}</span></div>
              <div className="flex justify-between"><span className="text-slate-400">Total Rows</span><span className="font-mono">{dbStatus.totalDocs?.toLocaleString()}</span></div>
            </div>
          </div>
        )}
      </div>
      <span className="px-2 py-0.5 bg-slate-100 rounded font-mono font-medium">
        v{version.push_version || "—"}
      </span>
      <span className="hidden sm:inline text-slate-400">
        {prettyDate(version.push_date)}
      </span>
      {version.branch && (
        <span className="hidden md:inline text-slate-400 font-mono">
          · {version.branch}
        </span>
      )}
    </div>
  );
}
